import { useState, useEffect, useCallback } from 'react'
import { Tune as FiltersIcon } from '@mui/icons-material'
import CloseIcon from '@mui/icons-material/Close'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import { openLocalFilterModal } from 'app/entities/store/modalsSlice'

import { selectSavedFilter } from 'features/RiskManagement/Components/LocalFilter/localFilterSelectors'

const LocalFilterButton = () => {
  const dispatch = useAppDispatch()
  const localFilter = useAppSelector(selectSavedFilter)
  const [filtersApplied, setFiltersApplied] = useState<number>(0)

  // Syncs the number of local filters applied to the local filter in the store
  useEffect(() => {
    const lineFilterCount = localFilter.segments?.length ?? 0
    const hmcaFilterCount = localFilter.hmca?.length ?? 0
    const classLocationFilterCount = localFilter.classLocations?.length ?? 0
    const riskLevelsFilterCount = localFilter.riskLevels?.length ?? 0

    setFiltersApplied(
      lineFilterCount +
        hmcaFilterCount +
        classLocationFilterCount +
        riskLevelsFilterCount
    )
  }, [localFilter])

  const openLocalFilter = useCallback(() => {
    dispatch(openLocalFilterModal())
  }, [dispatch])

  return (
    <div className='flex'>
      <button
        className='mx-2 flex items-center px-2 text-gray-700'
        onClick={openLocalFilter}
      >
        <FiltersIcon fontSize='small' />
        <div className='ml-1 font-medium'>Filters</div>
        {filtersApplied > 0 && (
          <div className='flex'>
            <div
              className={[
                'ml-2 px-2',
                'rounded',
                'bg-lighthouseBlue',
                'py-1 text-white',
                'text-sm font-medium'
              ].join(' ')}
              data-testid='filters-applied'
            >
              {filtersApplied}
            </div>
            {false && (
              <button
                className='text-gray-300'
                onClick={() => setFiltersApplied(0)}
              >
                <CloseIcon fontSize='small' />
              </button>
            )}
          </div>
        )}
      </button>
    </div>
  )
}

export default LocalFilterButton
